/**
 * @generated SignedSource<<fb49067befbaf9aaf5b4dfd201ccfdfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationFlourishPraiseLeaderboardItem$data = {
  readonly id: string;
  readonly praise: number;
  readonly title: string;
  readonly " $fragmentType": "WidgetIntegrationFlourishPraiseLeaderboardItem";
};
export type WidgetIntegrationFlourishPraiseLeaderboardItem$key = {
  readonly " $data"?: WidgetIntegrationFlourishPraiseLeaderboardItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationFlourishPraiseLeaderboardItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIntegrationFlourishPraiseLeaderboardItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "praise",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "WidgetIntegrationFlourishPraiseLeaderboardItem",
  "abstractKey": null
};

(node as any).hash = "566f5bbe5671abbe0fc8722080fd12bd";

export default node;
